import { AudioPresets, ScreenSharePresets, VideoPresets } from 'livekit-client';
export async function getDevices(kind) {
    var _a, _b, _c, _d, _e;
    let constraints = {
        audio: true,
    };
    if (kind === 'videoinput') {
        constraints = {
            video: true,
        };
    }
    const stream = (_b = (await ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.getUserMedia(constraints)))) !== null && _b !== void 0 ? _b : {};
    let devices = (_d = (await ((_c = navigator === null || navigator === void 0 ? void 0 : navigator.mediaDevices) === null || _c === void 0 ? void 0 : _c.enumerateDevices()))) !== null && _d !== void 0 ? _d : [];
    devices = devices.filter((device) => device.kind === kind);
    if (devices.length > 1 && devices[0].deviceId === 'default') {
        // find another device with matching group id, and move that to 0
        const defaultDevice = devices[0];
        for (let i = 1; i < devices.length; i += 1) {
            if (devices[i].groupId === defaultDevice.groupId) {
                const temp = devices[0];
                devices[0] = devices[i];
                devices[i] = temp;
                break;
            }
        }
        return devices.filter((device) => device !== defaultDevice);
    }
    if (Object.keys(stream).length > 0) {
        ((_e = stream === null || stream === void 0 ? void 0 : stream.getTracks()) !== null && _e !== void 0 ? _e : []).forEach(function (track) {
            track.stop();
        });
    }
    return devices;
}
const dec2hex = (dec) => {
    return dec.toString(16).padStart(2, '0');
};
export const randomString = (len = 20) => {
    const arr = new Uint8Array(len / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, dec2hex).join('');
};
export const randomInteger = (len = 10) => {
    const arr = new Uint8Array(len / 2);
    window.crypto.getRandomValues(arr);
    return Number(arr.join(''));
};
export const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};
export const getWebcamResolution = () => {
    var _a;
    const selected = (_a = window.DEFAULT_WEBCAM_RESOLUTION) !== null && _a !== void 0 ? _a : 'h720';
    let resolution = VideoPresets.h720.resolution;
    switch (selected) {
        case 'h90':
            resolution = VideoPresets.h90.resolution;
            break;
        case 'h180':
            resolution = VideoPresets.h180.resolution;
            break;
        case 'h216':
            resolution = VideoPresets.h216.resolution;
            break;
        case 'h360':
            resolution = VideoPresets.h360.resolution;
            break;
        case 'h540':
            resolution = VideoPresets.h540.resolution;
            break;
        case 'h720':
            resolution = VideoPresets.h720.resolution;
            break;
        case 'h1080':
            resolution = VideoPresets.h1080.resolution;
            break;
        case 'h1440':
            resolution = VideoPresets.h1440.resolution;
            break;
        case 'h2160':
            resolution = VideoPresets.h2160.resolution;
            break;
    }
    return resolution;
};
export const getScreenShareResolution = () => {
    var _a;
    const selected = (_a = window.DEFAULT_SCREEN_SHARE_RESOLUTION) !== null && _a !== void 0 ? _a : 'h1080fps15';
    let resolution = ScreenSharePresets.h1080fps15.resolution;
    switch (selected) {
        case 'h360fps3':
            resolution = ScreenSharePresets.h360fps3.resolution;
            break;
        case 'h720fps5':
            resolution = ScreenSharePresets.h720fps5.resolution;
            break;
        case 'h720fps15':
            resolution = ScreenSharePresets.h720fps15.resolution;
            break;
        case 'h1080fps15':
            resolution = ScreenSharePresets.h1080fps15.resolution;
            break;
        case 'h1080fps30':
            resolution = ScreenSharePresets.h1080fps30.resolution;
            break;
    }
    return resolution;
};
export const getAudioPreset = () => {
    var _a;
    const selected = (_a = window.DEFAULT_AUDIO_PRESET) !== null && _a !== void 0 ? _a : 'music';
    let preset = AudioPresets.music;
    switch (selected) {
        case 'telephone':
            preset = AudioPresets.telephone;
            break;
        case 'speech':
            preset = AudioPresets.speech;
            break;
        case 'music':
            preset = AudioPresets.music;
            break;
        case 'musicStereo':
            preset = AudioPresets.musicStereo;
            break;
        case 'musicHighQuality':
            preset = AudioPresets.musicHighQuality;
            break;
        case 'musicHighQualityStereo':
            preset = AudioPresets.musicHighQualityStereo;
            break;
    }
    return preset;
};
/**
 * getAccessToken will try to get token by the following:
 * from `access_token` GET/Search parameter from URL OR
 * from cookie name `pnm_access_token`
 * */
export const getAccessToken = () => {
    var _a;
    const urlSearchParams = new URLSearchParams(window.location.search);
    let accessToken = urlSearchParams.get('access_token');
    if (accessToken) {
        return accessToken;
    }
    // now let's check from cookies
    const tokenCookieName = 'pnm_access_token';
    accessToken =
        ((_a = document.cookie
            .match('(^|;)\\s*' + tokenCookieName + '\\s*=\\s*([^;]+)')) === null || _a === void 0 ? void 0 : _a.pop()) || '';
    if (accessToken) {
        return accessToken;
    }
    return null;
};
